import React from 'react';
import { cn } from '~/lib/utils';
import styles from './SupersededQuote.module.css';
import type { ChatTheme } from './theme';
import { chatThemeClass } from './theme';
import { useV15Theme } from '~/design-system/components/v1_5/theme-context';

export interface SupersededQuoteProps {
  /** The decision as it was originally stated. Kept verbatim — a paraphrase is a second decision. */
  children: React.ReactNode;
  theme?: ChatTheme;
  className?: string;
}

/**
 * An earlier decision that a later one overrode (*Decision superseded* — "an earlier call the later
 * one overrode. it stays, or the thread lies.").
 *
 * A `blockquote` behind a 2px left rule at **0.55 opacity on the whole block**. The opacity is the
 * component: it multiplies the rule down along with the words so the two fade as one object. Do
 * not substitute a dimmer text token over a full-strength rule — see the note in the stylesheet.
 */
export function SupersededQuote({ children, theme: themeProp, className }: SupersededQuoteProps) {
  const theme = useV15Theme(themeProp);
  return (
    <blockquote className={cn(chatThemeClass(theme), styles.root, className)}>{children}</blockquote>
  );
}
